export interface IAppendPreviewPageInput {
  pagePreviewId: string;
  imageUrl: string;
}

class AppendPreviewPageInput {
  public readonly pagePreviewId: string;
  public readonly imageUrl: string;

  constructor({ pagePreviewId, imageUrl }: { pagePreviewId: string; imageUrl: string }) {
    this.pagePreviewId = pagePreviewId;
    this.imageUrl = imageUrl;
  }

  public toJSON = () => ({
    pagePreviewId: this.pagePreviewId,
    imageUrl: this.imageUrl,
  });

  public static fromJSON = (json: IAppendPreviewPageInput): AppendPreviewPageInput => {
    const { pagePreviewId, imageUrl } = Object.assign({}, json);

    if (typeof pagePreviewId !== 'string') throw new Error('.pagePreviewId must be a string');
    if (typeof imageUrl !== 'string') throw new Error('.imageUrl must be a string');

    return new AppendPreviewPageInput({
      pagePreviewId,
      imageUrl,
    });
  };
}

export default AppendPreviewPageInput;
